<div class="container-fluid g-0 m-0">
  <div class="row g-0 m-0 d-flex pt-5 align-items-center">
    <div class="col-md-1 d-flex pe-4 justify-content-end">
      <div class="button-back pb-3" (click)="onBack()">
        <svg-icon alt="Back" src="assets/core/back-button.svg"></svg-icon>
      </div>
    </div>
    <div class="col-md-11">
      <h2 class="col pb-2 m-0 title">
        {{ "ONDEMANDREAD" | translate }}
      </h2>
      @if (currentRouteSegment === "energy") {
        <p class="col subtitle">{{ "ONDEMANDENERGY_SUBTITLE" | translate }}</p>
      } @else if (this.currentRouteSegment === "power-demand") {
        <p class="col subtitle">
          {{ "ONDEMANDPOWERDEMAND_SUBTITLE" | translate }}
        </p>
      } @else if (this.currentRouteSegment === "load-profile") {
        <p class="col subtitle">
          {{ "ONDEMANDLOADPROFILE_SUBTITLE" | translate }}
        </p>
      } @else if (this.currentRouteSegment === "instantaneous-object") {
        <p class="col subtitle">
          {{ "ONDEMANDINSTANTANEOUS_SUBTITLE" | translate }}
        </p>
      } @else if (this.currentRouteSegment === "billing-data") {
        <p class="col subtitle">{{ "ONDEMANDBILLING_SUBTITLE" | translate }}</p>
      } @else if (this.currentRouteSegment === "custom-register") {
        <p class="col subtitle">
          {{ "ONDEMANDCUSTOMREG_SUBTITLE" | translate }}
        </p>
      }
    </div>
  </div>
  <form #crudform="ngForm" (ngSubmit)="onSubmit()">
    <div class="form-item">
      <label class="form-label" for="meterNo">{{
        "DEVICESETUP_METERNO" | translate
      }}</label>
      <div class="form-input">
        <input
          id="meterNo"
          [(ngModel)]="requestData.meterNo"
          #meterNo="ngModel"
          name="meterNo"
          type="text"
          pattern="^[0-9]+$"
          required
        />
        @if (crudform.submitted && meterNo.invalid) {
          {{ "DEVICESETUP_METERNO" | translate
          }}{{ "DEVICESETUP_ISREQUIRED" | translate }}
        }
        @if (!requestData.meterNo || requestData.meterNo.trim() === "") {
          <div class="validation-instruction">
            {{ "DEVICESETUP_METERNODESC" | translate }}
          </div>
        } @else if (meterNo.invalid && meterNo.errors?.["pattern"]) {
          <div class="validation-error">
            {{ "METERNUMBER_ERROR" | translate }}
          </div>
        }
      </div>
    </div>
    <div class="form-item">
      <label class="form-label" for="dataDate">{{
        "DATADATE" | translate
      }}</label>
      <div class="form-input">
        <div class="date-container" (click)="toggleDatepicker()">
          <span class="ps-2 pe-2">{{ "DATE" | translate }}</span>
          <div class="date-input">
            <input
              class="w-max-content"
              id="dataDate"
              [(ngModel)]="selectedDate"
              #dataDate="ngModel"
              name="dataDate"
              type="text"
              required
              readonly
            />
            <img alt="Calendr" src="assets/device/calendar.svg" />
          </div>
        </div>
        @if (isDatepickerShown) {
          <div class="overlay-light" (click)="toggleDatepicker()"></div>
          <app-datepicker
            #d
            [scale]="1.1"
            [range]="true"
            [inputFromDate]="inputFromDate"
            [inputToDate]="inputToDate"
            (dateRangeChanged)="onDateRangeChanged($event)"
          ></app-datepicker>
        }
        @if (crudform.submitted && dataDate.invalid) {
          <div class="validation-error">
            {{ "DATADATE" | translate }}
            {{ "DEVICESETUP_ISREQUIRED" | translate }}.
          </div>
        } @else if (dataDate.invalid) {
          <div class="validation-instruction">
            {{ "ENERGYREGISTERSSETUP_DATADATEDESC" | translate }}.
          </div>
        }
      </div>
    </div>
    <div class="horizontal-line"></div>

    <div class="form-item-button">
      <button class="button-submit" [disabled]="crudform.invalid" type="submit">
        {{ "CONTINUE" | translate }}
      </button>
    </div>
  </form>
</div>
